import { useContext } from "react";
import { HomeContext } from "../../Context/HomeContext";
import Lottie from "lottie-react";
import animationFile from "./Animation - 1729240983685.json";
import animationFile2 from "./dl9sEG9WBs.json";

export default function LoadingMain() {
  const { loadingMain } = useContext(HomeContext);

  return (
    <>
      <div
        className="LoadingMain"
        style={{
          display: loadingMain ? "flex" : "none",
        }}
      >
        <Lottie animationData={animationFile2} loop={true} />
      </div>
    </>
  );
}
